import React from 'react';
import { Segment, Container, Header, Image, Button, Icon } from 'semantic-ui-react';

export default function HomePage({history}) {
    console.log('in HomePage....');
    const qrIdParams = new URLSearchParams(window.location.search); 
      const qrIdURL = qrIdParams.get('id');
      console.log(qrIdURL);
    return (
        <Segment inverted textAlign='center' vertical className='masthead'>
            <Container>
                <Header as='h1' inverted>
                    <Image size='massive' src='/assets/logo.png' style={{marginBottom: 12, width: 300}} />
                    
                </Header>
                <Button onClick={() => history.push('/offers')} size='huge' inverted>
                    Offers
                    <Icon name='right arrow' inverted />
                </Button>
            </Container>
        </Segment>
    )
}